import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  if(environment.app === 'innovateBackendApp-Prod'){
    console.info = ()=> {};
   // console.error = () => {};
  }
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(`[Main] bootstrapModule error ${JSON.stringify(err)}`));
